export enum SchedulerObjectType {
  Item = 0,
  Group = 1,
}
